/**
 * Auto CEP — preenche endereço via ViaCEP ao digitar o CEP completo.
 *
 * Funciona com o componente Address (class-address.php) e qualquer
 * container que tenha campos .lb-rua, .lb-bairro, .lb-cidade, .lb-uf
 * (e .lb-numero, para onde o foco vai depois do preenchimento).
 *
 * - Dispara no `input` assim que o campo tem 8 dígitos (com ou sem máscara),
 *   sem esperar o campo perder o foco. O `blur` fica só como reserva.
 * - Não repete a busca para o mesmo CEP; apagar um dígito libera de novo.
 * - Sucesso: preenche os campos (eventos nativos `input`/`change`, para o
 *   x-model do Alpine acompanhar) e leva o foco para o Número — ou para a
 *   Rua, quando o CEP é geral da cidade e veio sem logradouro. Só move o
 *   foco se a pessoa ainda estiver no campo do CEP (nunca rouba o foco).
 * - CEP inexistente/erro: mostra o "x" e o foco fica no CEP.
 * - Campo com `data-lb-autocep="off"` tem busca própria (ficha de matrícula)
 *   e é ignorado aqui.
 *
 * Feedback visual: loading spinner no label, highlight nos campos preenchidos,
 * ícone de sucesso (check) ou falha (x) que desaparece em 5s.
 *
 * @package Labead
 */
(function ($) {
	var ICON_TIMEOUT = 5000;

	/**
	 * Cria elemento SVG inline (evita dependência de Lucide estar carregado).
	 */
	function svgIcon(type) {
		var svg = {
			loader: '<svg class="lb-cep-spin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>',
			check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
			x: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
		};
		return $(svg[type]);
	}

	/**
	 * Label do campo de CEP (label[for=id] → coluna → pai).
	 */
	function cepLabel($cep) {
		var id = $cep.attr('id');
		if (id) {
			var sel = 'label[for="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]';
			var $byFor = $(sel);
			if ($byFor.length) return $byFor.first();
		}
		var $col = $cep.closest('[class*="col-span"]');
		var $label = $col.find('label').first();
		if (!$label.length) $label = $cep.parent().find('label').first();
		if (!$label.length) $label = $cep.parent().parent().find('label').first();
		return $label;
	}

	/**
	 * Mostra indicador de status ao lado do label do CEP.
	 */
	function showStatus($cep, type) {
		var $label = cepLabel($cep);
		if (!$label.length) return $();
		$label.find('.lb-cep-status').remove();

		var $status = $('<span class="lb-cep-status"></span>').css({
			display: 'inline-flex',
			alignItems: 'center',
			marginLeft: '6px',
			verticalAlign: 'middle',
		});
		$status.append(svgIcon(type));
		var $span = $label.find('span').first();
		if ($span.length) {
			$span.after($status);
		} else {
			$label.append($status);
		}

		if (type !== 'loader') {
			setTimeout(function () {
				$status.fadeOut(300, function () { $(this).remove(); });
			}, ICON_TIMEOUT);
		}

		return $status;
	}

	/**
	 * Aplica highlight temporário nos campos preenchidos.
	 */
	function highlightField($field) {
		$field
			.css({ transition: 'box-shadow .3s ease, border-color .3s ease' })
			.addClass('lb-cep-filled');
		setTimeout(function () {
			$field.removeClass('lb-cep-filled');
		}, 1500);
	}

	/**
	 * Endereço do próprio CEP: o menor ancestral que contém o campo de rua.
	 * Mantém dois endereços na mesma página (ou no mesmo form) independentes.
	 */
	function addressScope($cep) {
		var $s = $cep.parent();
		while ($s.length && !$s.is('body')) {
			if ($s.find('.lb-rua').length) return $s;
			$s = $s.parent();
		}
		return $cep.closest('form, [lbform], .lb-address-wrapper');
	}

	/**
	 * Grava o valor e avisa quem escuta: eventos NATIVOS (o jQuery .trigger()
	 * não chega ao x-model do Alpine; o dispatch nativo chega aos dois).
	 */
	function setValue($field, value) {
		var el = $field[0];
		if (!el) return;
		el.value = value || '';
		if (el.tagName !== 'SELECT') {
			el.dispatchEvent(new Event('input', { bubbles: true }));
		}
		el.dispatchEvent(new Event('change', { bubbles: true }));
		highlightField($field);
	}

	function isFocusable($el) {
		var el = $el[0];
		return !!el && !el.disabled && !el.readOnly && el.type !== 'hidden' && el.offsetParent !== null;
	}

	/**
	 * Depois de preencher: foco no Número (ou na Rua, se o CEP veio sem
	 * logradouro). Só se a pessoa ainda estiver no CEP.
	 */
	function focusNext($cep, $scope, dados) {
		if (document.activeElement !== $cep[0]) return;

		var $target = $scope.find('.lb-numero').first();
		if (!$target.length) {
			$target = $scope.find('input[name*="numero"]').not('[type="hidden"]').first();
		}
		var $rua = $scope.find('.lb-rua').first();
		if (!dados.logradouro && isFocusable($rua)) {
			$target = $rua;
		}
		if (!isFocusable($target)) return;

		$target[0].focus();
		if ($target.val()) {
			try { $target[0].select(); } catch (e) { /* type=number em alguns navegadores */ }
		}
	}

	/**
	 * Busca CEP e preenche campos.
	 */
	function fetchCep($cep) {
		if ($cep.is('[data-lb-autocep="off"]')) return;

		var cep = String($cep.val() || '').replace(/\D/g, '');
		if (!/^[0-9]{8}$/.test(cep)) return;

		// Evita busca duplicada para o mesmo CEP (input + blur, eventos repetidos).
		if ($cep.data('lb-last-cep') === cep) return;
		$cep.data('lb-last-cep', cep);

		var $scope = addressScope($cep);
		var $rua = $scope.find('.lb-rua').first();
		var $bairro = $scope.find('.lb-bairro').first();
		var $cidade = $scope.find('.lb-cidade').first();
		var $uf = $scope.find('.lb-uf').first();

		showStatus($cep, 'loader');

		fetch('https://viacep.com.br/ws/' + encodeURIComponent(cep) + '/json/')
			.then(function (r) { return r.json(); })
			.then(function (dados) {
				// A pessoa já trocou o CEP enquanto a resposta vinha: descarta.
				if (String($cep.val() || '').replace(/\D/g, '') !== cep) return;

				if (!dados || dados.erro) {
					showStatus($cep, 'x');
					return;
				}

				setValue($rua, dados.logradouro);
				setValue($bairro, dados.bairro);
				setValue($cidade, dados.localidade);
				setValue($uf, dados.uf);

				showStatus($cep, 'check');
				focusNext($cep, $scope, dados);
			})
			.catch(function () {
				// Falha de rede: libera nova tentativa com o mesmo CEP.
				$cep.removeData('lb-last-cep');
				showStatus($cep, 'x');
			});
	}

	// Dispara ao digitar (quando atinge 8 dígitos). Abaixo disso, libera o
	// mesmo CEP para buscar de novo quando for completado outra vez.
	$(document).on('input', '[lbmask="cep"]', function () {
		var $cep = $(this);
		var digits = String($cep.val() || '').replace(/\D/g, '');
		if (digits.length === 8) {
			fetchCep($cep);
		} else {
			$cep.removeData('lb-last-cep');
		}
	});

	// Mantém disparo no blur como fallback (ex: valor posto por script).
	$(document).on('blur', '[lbmask="cep"]', function () {
		fetchCep($(this));
	});
})(jQuery);

/**
 * Estilos injetados para feedback visual do auto-CEP.
 */
(function () {
	var style = document.createElement('style');
	style.textContent = [
		'@keyframes lb-cep-spin { to { transform: rotate(360deg); } }',
		'.lb-cep-spin { animation: lb-cep-spin .7s linear infinite; }',
		'.lb-cep-filled {',
		'  box-shadow: 0 0 0 2px rgba(22,163,74,.35) !important;',
		'  border-color: #16a34a !important;',
		'}',
	].join('\n');
	document.head.appendChild(style);
})();
